import $http from '@/config/request'

export const getUserCertificateApi = params => {
  return $http.post(`/user/userCertificate/getCertificate?mobile=${params.mobile}&name=${params.name}&userNo=${params.userNo}`, )
}


export const downloadUserCertificateApi = params => {
  return $http.get(`/user/userCertificate/downCertificate?userNo=${params.userNo}&certificate_url=${params.certificate_url}`, )
}